/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Granted_DescInputs */



/**
* | output |
* | --- |
* | "Access to the {provider} integration was granted to a member." |
*
* @param {Audit_Details_Integration_Granted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_granted_desc = /** @type {((inputs: Audit_Details_Integration_Granted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Granted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Einem Mitglied wurde Zugriff auf die Integration ${i?.provider} erteilt.`)
	return /** @type {LocalizedString} */ (`Access to the ${i?.provider} integration was granted to a member.`)
});